<template>
  <div>
    <TextArea
      title="Motivo da Reprovação"
      field="rejectionReason"
      :required="true"
      :maxLength="500"
      v-model="rejectionReason"
    />
    <CheckboxGroup
      title="Marque as opções (se houver)"
      :stacked="true"
      :options="[
      { text: 'Excluir Contas a Receber', value: 'removeReceive' },
      { text: 'Excluir Contas a Pagar', value: 'removePay' },
    ]"
      v-model="optionsSelected"
    />
    <div class="text-center">
      <Button
        _key="btnRentReject"
        title="Reprovar"
        type="danger"
        size="medium"
        :clicked="update"
        :disabled="!rejectionReason"
      />
    </div>
  </div>
</template>
<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";
import CheckboxGroup from "@nixweb/nixloc-ui/src/component/forms/CheckboxGroup";
import TextArea from "@nixweb/nixloc-ui/src/component/forms/TextArea";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "RentReject",
  props: {
    rentId: String,
  },
  components: {
    Button,
    CheckboxGroup,
    TextArea,
  },
  data() {
    return {
      urlUpdate: "/api/v1/rental/rent/reject",
      optionsSelected: [],
      rejectionReason: "",
    };
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
    update() {
      let params = {
        url: this.urlUpdate,
        obj: {
          rentId: this.rentId,
          options: this.optionsSelected,
          rejectionReason: this.rejectionReason,
        },
      };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "rentRejected" });
          this.hideModal();
        }
        this.removeLoading(["btnRentReject"]);
      });
    },
  },
};
</script>